export const BLOG = {
  path: "/blog",
  title: "Blog | ANGKOR Cambodian Flavours",
  description: "Stories, dish guides and Cambodian food culture from ANGKOR, a Cambodian restaurant at 389 Spencer St, West Melbourne.",
} as const;

export const BEEF_LOC_LAC_ARTICLE = {
  path: "/blog/beef-loc-lac-melbourne",
  title: "Beef Loc Lac in Melbourne: Cambodia's Peppery Wok-Seared Beef | ANGKOR",
  headline: "Beef Loc Lac in Melbourne: Cambodia's Peppery, Wok-Seared Beef",
  description: "What is Cambodian beef loc lac? How it's cooked, how to eat it, and where to try it in West Melbourne: ANGKOR, 389 Spencer St, near Marvel Stadium.",
  image: "/manus-storage/beef-loc-lac-premium_c84dd63b.webp",
  imageAlt: "Beef Loc Lac with fried egg and salad at ANGKOR West Melbourne",
  datePublished: "2026-10-19",
  dateLabel: "19 October 2026",
  byline: "By the ANGKOR team",
  excerpt: "Here is what loc lac is, what makes it different from a regular stir-fry, how to eat it, and where to order it at ANGKOR.",
} as const;
